import {
    BsHouse,
    BsShopWindow
} from "react-icons/bs";
import {
    PiBed
} from "react-icons/pi";

export const enquiryOptions = (t) => ({
    "Studio": {
        value: "Studio",
        label: t("studio"),
        icon: <BsHouse size={18} />,
    },
    "1 Bedroom": {
        value: "1 Bedroom",
        label: t("1bhk"),
        icon: <PiBed size={18} />,
    },
    "2 Bedrooms": {
        value: "2 Bedrooms",
        label: t("2bhk"),
        icon: <PiBed size={18} />,
    },
    "3 Bedrooms": {
        value: "3 Bedrooms",
        label: t("3bhk"),
        icon: <PiBed size={18} />,
    },
    "4 Bedrooms": {
        value: "3 Bedrooms",
        label: t("4bhk"),
        icon: <PiBed size={18} />,
    },
    "Retail": {
        value: "Retail",
        label: t("retail"),
        icon: <BsShopWindow size={18} />,
    },
});
